import { render, staticRenderFns } from "./RirekishoEdit.vue?vue&type=template&id=6f20682c&scoped=true"
import script from "./RirekishoEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./RirekishoEdit.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RirekishoEdit.vue?vue&type=style&index=0&id=6f20682c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f20682c",
  null
  
)

export default component.exports